import React, { useState } from 'react';
import './Modal.css'; // Importation du fichier CSS pour le modal

const Modal = ({ showModal, setShowModal, content }) => {
  if (!showModal) return null; // Ne rien afficher si le modal est fermé

  return (
    <div className="modal-overlay" onClick={() => setShowModal(false)}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={() => setShowModal(false)}>
          ×
        </button>
        <div className="modal-body">
          {content}
        </div>
      </div>
    </div>
  );
};

export default Modal;
